'use client';
import React from 'react';
import { MantineProvider, localStorageColorSchemeManager } from '@mantine/core';
import mantineTheme from '@/theme';

// Simple, lightweight ThemeProvider focused on fast initial render
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <MantineProvider
      theme={mantineTheme}
      defaultColorScheme="auto"
      colorSchemeManager={localStorageColorSchemeManager({ key: 'mantine-color-scheme' })}
    >
      {children}
    </MantineProvider>
  );
}
